import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherAlert, CreateWeatherAlertDto } from 'types';

export const createWeatherAlert = (
  data: CreateWeatherAlertDto
): Promise<WeatherAlert> => {
  return axios.post('/api/weather/alerts', data);
};

type UseCreateWeatherAlertOptions = {
  config?: MutationConfig<typeof createWeatherAlert>;
};

export const useCreateWeatherAlert = ({
  config,
}: UseCreateWeatherAlertOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherAlerts) {
        queryClient.setQueryData(
          ['weatherAlerts'],
          context.previousWeatherAlerts
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherAlerts']);
      queryClient.invalidateQueries(['dishes']);
    },
    ...config,
    mutationFn: createWeatherAlert,
  });
};
